import React, { useCallback } from 'react';

import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { IconButton, Stack, Typography } from '@mui/material';

import { colors } from 'src/utils/customColors';

// Import SVGs as React components
import { ReactComponent as FineIcon } from 'src/images/Fine.svg';
import { ReactComponent as SetupIcon } from 'src/images/Setup.svg';
// import { ReactComponent as SearchIcon } from 'src/images/Search.svg';
import { ReactComponent as StudentIcon } from 'src/images/Student.svg';
import { ReactComponent as ProjectIcon } from 'src/images/Project.svg';
import { ReactComponent as ContractIcon } from 'src/images/Contract.svg';
import { ReactComponent as TimeTrackingIcon } from 'src/images/TimeTracking.svg';
import { ReactComponent as CancellationIcon } from 'src/images/Cancellation.svg';
import { ReactComponent as VerificationIcon } from 'src/images/Verification.svg';
import { ReactComponent as PayrollIcon } from 'src/images/Payroll.svg';
// import { ReactComponent as AutoAcceptanceIcon } from 'src/images/DrawerIcons/AutoAcceptance.svg';

import useMessenger from 'src/utils/hooks/useMessenger';
import PageLayout, {
  UnderConstructionMessage,
} from 'src/components/PageLayout';

interface MenuItem {
  url: string;
  text: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const iconStylesSx = {
  '& svg path': {
    fill: colors.darkerBlue,
  },
};

export const homeIcons: Array<MenuItem> = [
  { text: 'Projects', icon: ProjectIcon, url: '/projects' },
  { text: 'Contracts', icon: ContractIcon, url: '/contracts' },
  { text: 'Cancellations', icon: CancellationIcon, url: '/cancellations' },
  { text: 'Students', icon: StudentIcon, url: '/students' },
  { text: 'Verification', icon: VerificationIcon, url: '/verifications' },
  { text: 'Payroll', icon: PayrollIcon, url: '/payroll' },
  { text: 'Time Tracking', icon: TimeTrackingIcon, url: '/time_tracking' },
  { text: 'Fines', icon: FineIcon, url: '/fines' },
  // {
  //   text: 'Auto Acceptance',
  //   icon: AutoAcceptanceIcon,
  //   url: '/auto_acceptance',
  // },
  { text: 'Setup', icon: SetupIcon, url: '/setup' },
  // { text: 'Search', icon: SearchIcon, url: 'disabled' },
];

export default function HomePage() {
  const navigate = useNavigate();
  const messenger = useMessenger();

  const handleNavigation = useCallback(
    (text: string, url: string) => {
      if (url === 'disabled') {
        messenger.info(<UnderConstructionMessage text={text} />);
      } else {
        navigate(url);
      }
    },
    [messenger, navigate],
  );

  return (
    <PageLayout title="Home">
      <Stack alignItems="center" justifyItems="center">
        <Grid
          container
          rowSpacing={12}
          pt={4}
          alignItems="center"
          alignContent="center"
        >
          {homeIcons.map(({ text, icon: Icon, url }) => {
            return (
              <Grid key={text} size={{ xs: 12, sm: 6, md: 3 }}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  flexDirection="column"
                >
                  <IconButton
                    sx={iconStylesSx}
                    onClick={() => handleNavigation(text, url)}
                  >
                    <Icon width={80} height={80} />
                  </IconButton>
                  <Typography variant="subtitle1">{text}</Typography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </PageLayout>
  );
}
